module.exports = __webpack_public_path__ + "img/data-item3.b74fb794.png";